/**
 * Macbook — Generated by hearth-asset-pipeline
 * Furniture: 1×1 tiles
 * Generated: 2026-04-11T05:57:09.461Z
 *
 * This is a procedural isometric furniture renderer produced from a 3D model.
 * Integrates with Hearth's renderFurniture() dispatch and isoBox primitives.
 */

import { renderIsoAsset, type IsoAssetDef } from "../../render/iso-engine.js";

/** Furniture registry metadata */
export const Macbook_META = {
  id: "Macbook",
  name: "Macbook",
  tileWidth: 1,
  tileHeight: 1,
  isoWidth: 22,
  isoDepth: 25,
  canonicalRot: 0 as const,
  interactionAnchors: [
    { type: "use_point", localWx: 0, localWy: 0, elevation: 0, faceDir: "S" },
  ],
} as const;

/** Declarative asset definition — pure data, no rendering code */
export const Macbook_DEF: IsoAssetDef = {
  id: "Macbook",
  name: "Macbook",
  tile: [1, 1],
  geometry: { w: 32, d: 8, h: 14 },
  faces: {
    top: {
      base: "#0d0d0d",
      palette: ["#0d0d0d", "#898989", "#9c9c9c", "#f5f5f5", "#545454"],
      metalness: 0.65,
      roughness: 0.87,
      opacity: 1.00,
      emissive: "#c0c0c0",
      materialType: "metal",
      gradient: { stops: [[0.00, "#5c5c5c"], [0.33, "#636363"], [0.67, "#383838"], [1.00, "#e0e0e0"]], strength: 0.837 },
      grain: { scale: 2.0, contrast: 0.300, angle: 0 },
      specular: { x: 0.46, y: 0.49, radius: 0.60, intensity: 0.71 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    left: {
      base: "#757575",
      palette: ["#757575", "#f2f2f2", "#040404", "#838383", "#5b5b5b"],
      metalness: 0.75,
      roughness: 0.74,
      opacity: 1.00,
      emissive: "#f5f5f5",
      materialType: "metal",
      gradient: { stops: [[0.00, "#919191"], [0.33, "#969696"], [0.67, "#7c7c7c"], [1.00, "#363636"]], strength: 0.692 },
      grain: { scale: 2.0, contrast: 0.300 },
      specular: { x: 0.43, y: 0.73, radius: 0.32, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    right: {
      base: "#3b3b3b",
      palette: ["#3b3b3b", "#656565", "#030303", "#2a2a2a", "#696969"],
      metalness: 0.75,
      roughness: 1.00,
      opacity: 1.00,
      materialType: "metal",
      gradient: { stops: [[0.00, "#515151"], [0.33, "#474747"], [0.67, "#484848"], [1.00, "#2b2b2b"]], strength: 0.625 },
      grain: { scale: 4.0, contrast: 0.300, angle: 0 },
      specular: { x: 0.39, y: 0.46, radius: 0.43, intensity: 0.68 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
  },
  anchors: [
    { type: "use_point", wx: 0, wy: 0, elevation: 0, dir: "S" },
  ],
};

/**
 * Render Macbook via the shared isometric material engine.
 * Drop-in compatible with Hearth's renderFurniture() dispatch.
 */
export function renderMacbook(
  ctx: CanvasRenderingContext2D,
  screenX: number,
  screenY: number,
  direction: 0 | 1 | 2 | 3,
  state: Record<string, unknown>,
  time: number,
): void {
  renderIsoAsset(ctx, Macbook_DEF, screenX, screenY, direction, state, time);
}